import {RICH_TEXT_FIELD} from '../../rich-text/rich-text-query';
import {fetchContentEntries} from '../content-entry/content-entry-query';
import {contentEntries} from '../content-entry/content-entry-query-builder';
import {BlogPost} from './blog-types';
import * as QueryBuilder from '../../craft/query/craft-query-builder';

export async function getBlogPostBySlug(slug: string): Promise<Readonly<BlogPost | undefined>> {
  try {
    const result = await fetchContentEntries<BlogPost>(
      contentEntries()
        .section(['blog'])
        .slug([slug])
        .fields([
          RICH_TEXT_FIELD,
          QueryBuilder.url('audioUrl'),
          QueryBuilder.url('blogDownloadUrl')
        ])
    );
    return result[0];
  } catch (error) {
    throw new Error(`Could not fetch post: ${error}`);
  }
}
